<template>
    <q-dialog v-model="showModal" :maximized="$q.screen.lt.md">
        <q-card style="min-width: 60vw;">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">{{$t('accepted_proof')}}</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup/>
            </q-card-section>

            <q-card-section class="scroll">
                <p class="text-body1 text-bold">{{title}}</p>
                <div v-html="description"></div>

                <q-inner-loading :showing="loading">
                    <q-spinner-gears size="50px" color="primary" />
                </q-inner-loading>
            </q-card-section>

            <q-card-actions align="right" class="q-pa-md">
                <q-btn color="primary" label="Back" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import Help from "Modules/Help/resources/models/Help"

export default {
    name: "GuideModal",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            loading: false,
            title: '',
            description: ''
        }
    },
    methods: {
        fetchGuide() {
            this.loading = true
            Help.show('limits/verify-source-funds', ({title, description}) => {
                this.title = title
                this.description = description
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
        open(val) {
            if (val && !this.description) {
                this.fetchGuide()
            }
        }
    },
    components: {},
}
</script>
<style>

</style>
